import parsePhoneNumber from 'libphonenumber-js';

export default function formatRawPhoneNumber(phoneNumber: string): string {
  return parsePhoneNumber(phoneNumber, 'US')?.format('NATIONAL') || phoneNumber;
}
